<app-datatable [dataSourceUrl]="dtDataSourceUrl"
               [settings]="dtSettings"
               (onInit)="onDtInit($event)"
               (onAction)="onDtAction($event)"
>
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="city">Város</th>
  <th data-data="postCode">Irányítószám</th>
  <th data-data="line1" class="long-text-100">Címsor 1</th>
  <th data-data="line2">Címsor 2</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
